import http from './http';
let url = '/api/adminApi/'
export default {
    //  部门列表
    getdeplst() {
        return http.get(url + 'tool/deplst')
    }

}